
import { defineComponent, SetupContext, computed } from "vue";
import { PLATE_DELETE_FOOD_STATUS } from "@/types/pantry";
import NativeClient from "@/client/native-client";
export default defineComponent({
  name: "PantryUsedUpCheckTagItem",
  props: {
    label: {
      type: String,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    active: {
      type: Number,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    /**
     * タグ押下を通知する
     */
    const onClick = () => {
      const foodStatus = (props.id == props.active) ? PLATE_DELETE_FOOD_STATUS.NONE : props.id;
      NativeClient.sendDebugLog("PantryUsedUpCheckTagItem onClick id=" + props.id + " foodStatus=" + foodStatus);
      context.emit("select-tag", foodStatus);
    };

    const styleBackground = computed(() => {
      const background = getComputedStyle(document.documentElement).getPropertyValue(
        props.id == props.active ? "--main-theme-color" : "--main-bg-color"
      );
      const border = getComputedStyle(document.documentElement).getPropertyValue(
        props.id == props.active ? "--main-theme-color" : "--border-color"
      );
      return { background: background, borderColor: border };
    });

    /**
     * アイテムの文字色を取得する
     */
    const getItemFontColor = () => {
      return getComputedStyle(document.documentElement).getPropertyValue(
        props.id == props.active ? "--tag-select-text-color" : "--main--text-color"
      );
    };

    const getImage = () => {
      if (props.id == PLATE_DELETE_FOOD_STATUS.THREW_AWAY) {
        return (props.id == props.active) ? 
          require("@/assets/images/used_close_white.png") : require("@/assets/images/used_close_black.png");
      } else {
        return (props.id == props.active) ? 
          require("@/assets/images/used_check_white.png") : require("@/assets/images/used_check_black.png");
      }
    };

    return {
      onClick,
      styleBackground,
      getItemFontColor,
      getImage
    };
  }
});
